import {
  Field,
  FieldControl,
  FieldIcon,
  FieldLabel,
  NumberInput,
} from "@prismicio/editor-ui"
import type { NumberContent } from "@prismicio/types-internal/lib/content"
import type { Number as NumberT } from "@prismicio/types-internal/lib/customtypes"
import type { FC } from "react"

import { fieldInputPadding } from "./FieldTextInput"
import { getFieldLabel, getFieldPlaceholder } from "./utils"

type NumberFieldProps = Readonly<{
  content: NumberContent | undefined
  field: NumberT
  id: string
  onContentChange: (content: NumberContent | undefined) => void
  readOnly: boolean
}>

export const NumberField: FC<NumberFieldProps> = ({
  content,
  field,
  id,
  onContentChange,
  readOnly,
}) => {
  const valueAsNumber = Number(content?.value)
  const value = Number.isFinite(valueAsNumber) ? valueAsNumber : undefined

  return (
    <Field>
      <FieldIcon name="pin" />
      <FieldLabel htmlFor={id}>{getFieldLabel(field)}</FieldLabel>
      <FieldControl>
        <NumberInput
          id={id}
          value={value}
          min={field.config?.min}
          max={field.config?.max}
          padding={fieldInputPadding}
          placeholder={getFieldPlaceholder(field)}
          readOnly={readOnly}
          onValueChange={(value) => onContentChange(updateContent(value))}
        />
      </FieldControl>
    </Field>
  )
}

function updateContent(value: number | undefined): NumberContent | undefined {
  return value === undefined
    ? undefined
    : { __TYPE__: "FieldContent", type: "Number", value: String(value) }
}
